import {
  getAllForms,
  getFilteredCommunications,
  postFacebookErp,
  updateFacebook,
  deleteFacebookForm
} from '@/api/Erp'

export default {
  async getAllForms(page, size, product_id, search_text, token) {
    try {
      const response = await getAllForms.get({
        uriParams: {
          page,
          size,
          search_text
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async getFilteredCommunications(is_active, page, size, product_id, search_text, token) {
    try {
      const response = await getFilteredCommunications.get({
        uriParams: {
          is_active,
          page,
          size,
          product_id,
          search_text
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async postFacebookResource(payload, token) {
    try {
      const response = postFacebookErp.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async updateFacebook(payload, token) {
    try {
      const { id } = payload;

      const response = await updateFacebook.put(
        payload,
        {
          uriParams: {
            id
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async deleteFacebookForm(payload, token) {
    try {
      const facebookForm_id = payload.id
      const response = deleteFacebookForm.delete({
        uriParams: {
          id: facebookForm_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/facebook/resources.js